import * as Endpoints from '../Entities/EndPoints'
import Axios from '../Axios'

const API = Axios.getInstance

export const getRollData = (organizationId) => {
    const params = { organizationId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_ROLE, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}
export const getOrgLogoApi = (orgId, userId) => {
    const params = { orgId, userId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ORG_LOGO, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}
export const getHasOrgsApi = (emailId, userId) => {
    const params = { emailId, userId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_HAS_ORGS, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}
export const getVacancyGovApi = (orgId, userId) => {
    const params = { orgId, userId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_VACANCY_GOV, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getAllDepartmentByOrgId = (organizationId) => {
    const params = { organizationId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_DEPARTMENT_BY_ORGID, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getAllDesignationByOrgId = (organizationId) => {
    const params = { organizationId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_DESIGNATION_BY_ORGID, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getAllDesignationByDepId = (depId) => {
    let url = Endpoints.GET_ALL_DESIGNATION_BY_DEPT_ID
    url = url.replace('{departmentId}', depId)

    return API(Endpoints.API_ENDPOINT)
        .get(url)
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getAllFeatures = (userId) => {
    const params = { userId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_FEATURES, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const featureNavigationMenu = (userId, orgId) => {
    const params = { userId, orgId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.FEATURE_NAVIGATION_MENU, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getAllNotification = (userId) => {
    // const params = { userId }
    let URL = Endpoints.GET_ALL_NOTIFICATION
    URL = URL.replace('{userId}', userId)

    return API(Endpoints.API_ENDPOINT)
        .get(URL)
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const readNotificationById = (arrayOfId) => {
    return API(Endpoints.API_ENDPOINT)
        .put(Endpoints.READ_NOTIFICATION_BY_ID, arrayOfId)
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getExistingEmailandPhoneno = (payload) => {
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.GET_EXISTING_EMAIL_PHONENO, payload)
        .then((response) => response)
        .catch((err) => ({ err }))
}
